<template>
  <div class="main-wrapper pricing-page">
    <layouts-header></layouts-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content">
      <!-- Featured Plans -->
      <section class="featured-plan">
        <div class="container">
          <div class="section-heading">
            <h2>We Have Excellent Plans For You.</h2>
            <p class="sub-title">
              Choose monthly or yearly plans for uninterrupted access to our premium
              badminton facilities. Join us and experience convenient excellence.
            </p>
          </div>
          <div class="interset-btn">
            <div class="status-toggle d-inline-flex align-items-center">
              Monthly
              <input type="checkbox" id="status_1" class="check" />
              <label for="status_1" class="checktoggle">checkbox</label>
              Yearly
            </div>
          </div>
          <div class="price-wrap">
            <div class="row d-flex justify-content-center">
              <div class="col-lg-4 d-flex col-md-6">
                <!-- Price Card -->
                <div class="price-card flex-fill">
                  <div class="price-head">
                    <img src="@/assets/img/icons/price-01.svg" alt="Price" />
                    <h3>Professoinal</h3>
                  </div>
                  <div class="price-body">
                    <div class="per-month">
                      <h2><sup>$</sup><span>60.00</span></h2>
                      <span>Per Month</span>
                    </div>
                    <div class="features-price-list">
                      <h5>Features</h5>
                      <p>Everything in our free Upto 10 users.</p>
                      <ul>
                        <li class="active">
                          <i class="feather-check-circle"></i>Included : Quality checked
                          by envato
                        </li>
                        <li class="active">
                          <i class="feather-check-circle"></i>Included : Future updates
                        </li>
                        <li class="active">
                          <i class="feather-check-circle"></i>Technical Support
                        </li>
                        <li class="inactive">
                          <i class="feather-x-circle"></i>Add Listing
                        </li>
                        <li class="inactive">
                          <i class="feather-x-circle"></i>Approval of Listing
                        </li>
                      </ul>
                    </div>
                    <div class="price-choose">
                      <a href="javascript:;" class="btn viewdetails-btn">Choose Plan</a>
                    </div>
                    <div class="price-footer">
                      <p class="mb-0">
                        Use, by you or one client, in a single end product which end
                        users. charged for. The total price includes the item price and a
                        buyer fee.
                      </p>
                    </div>
                  </div>
                </div>
                <!-- /Price Card -->
              </div>
              <div class="col-lg-4 d-flex col-md-6">
                <!-- Price Card -->
                <div class="price-card flex-fill">
                  <div class="price-head expert-price">
                    <img src="@/assets/img/icons/price-02.svg" alt="Price" />
                    <h3>Expert</h3>
                    <span>Recommended</span>
                  </div>
                  <div class="price-body">
                    <div class="per-month">
                      <h2><sup>$</sup><span>60.00</span></h2>
                      <span>Per Month</span>
                    </div>
                    <div class="features-price-list">
                      <h5>Features</h5>
                      <p>Everything in our free Upto 10 users.</p>
                      <ul>
                        <li class="active">
                          <i class="feather-check-circle"></i>Included : Quality checked
                          by envato
                        </li>
                        <li class="active">
                          <i class="feather-check-circle"></i>Included : Future updates
                        </li>
                        <li class="active">
                          <i class="feather-check-circle"></i>Technical Support
                        </li>
                        <li class="inactive">
                          <i class="feather-x-circle"></i>Add Listing
                        </li>
                        <li class="inactive">
                          <i class="feather-x-circle"></i>Approval of Listing
                        </li>
                      </ul>
                    </div>
                    <div class="price-choose active-price">
                      <a href="javascript:;" class="btn viewdetails-btn">Choose Plan</a>
                    </div>
                    <div class="price-footer">
                      <p class="mb-0">
                        Use, by you or one client, in a single end product which end
                        users. charged for. The total price includes the item price and a
                        buyer fee.
                      </p>
                    </div>
                  </div>
                </div>
                <!-- /Price Card -->
              </div>
              <div class="col-lg-4 d-flex col-md-6">
                <!-- Price Card -->
                <div class="price-card flex-fill">
                  <div class="price-head">
                    <img src="@/assets/img/icons/price-03.svg" alt="Price" />
                    <h3>Enterprise</h3>
                  </div>
                  <div class="price-body">
                    <div class="per-month">
                      <h2><sup>$</sup><span>990.00</span></h2>
                      <span>Per Month</span>
                    </div>
                    <div class="features-price-list">
                      <h5>Features</h5>
                      <p>Everything in our free Upto 10 users.</p>
                      <ul>
                        <li class="active">
                          <i class="feather-check-circle"></i>Included : Quality checked
                          by envato
                        </li>
                        <li class="active">
                          <i class="feather-check-circle"></i>Included : Future updates
                        </li>
                        <li class="active">
                          <i class="feather-check-circle"></i>Technical Support
                        </li>
                        <li class="active">
                          <i class="feather-check-circle"></i>Add Listing
                        </li>
                        <li class="active">
                          <i class="feather-check-circle"></i>Approval of Listing
                        </li>
                      </ul>
                    </div>
                    <div class="price-choose">
                      <a href="javascript:;" class="btn viewdetails-btn">Choose Plan</a>
                    </div>
                    <div class="price-footer">
                      <p class="mb-0">
                        Use, by you or one client, in a single end product which end
                        users. charged for. The total price includes the item price and a
                        buyer fee.
                      </p>
                    </div>
                  </div>
                </div>
                <!-- /Price Card -->
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- /Featured Plans -->
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
export default {
  data() {
    return {
      title: "Pricing",
      text: "Home",
      text1: "Pricing",
    };
  },
};
</script>
